import { GENERIC_ACTION } from '../SearchResults/logic'

const INITIAL_STATE = {
  data: {},
  loading: false,
  error: false,
  flag: false,
};

const GET_NETWORK_VALUES = 'GET_NETWORK_VALUES';
const GET_NETWORK_VALUES_SUCCESS = 'GET_NETWORK_VALUES_SUCCESS';
const GET_NETWORK_VALUES_FAILURE = 'GET_NETWORK_VALUES_FAILURE';
const GET_NETWORK_VALUES_RESET = 'GET_NETWORK_VALUES_RESET';

export const getInstituteNetworkAction = (payload, meta = {}) => {
  return ({
    type: GENERIC_ACTION,
    payload,
    meta: {
      actionType: GET_NETWORK_VALUES,
      url: `${process.env.apiUrl}v0/institution/networks`,
      method: 'GET',
      auth: true,
      log: false, // for console
      ...meta,
    },
  })
}

export const instituteNetworkResetAction = () => ({
  type: GET_NETWORK_VALUES_RESET,
})

export function instituteNetworkReducer(state, action) {
  if (typeof state === 'undefined') {
    return INITIAL_STATE
  }
  switch (action.type) {
    case GET_NETWORK_VALUES: {
      return {
        data: {},
        loading: true,
        flag: false,
        error: false,
      }
    }
    case GET_NETWORK_VALUES_SUCCESS: {
      return {
        data: action.payload,
        loading: false,
        flag: true,
        error: false,
      }
    }
    case GET_NETWORK_VALUES_FAILURE: {
      return {
        data: {},
        loading: false,
        flag: false,
        error: true,
      }
    }
    case GET_NETWORK_VALUES_RESET: {
      return {
        data: {},
        loading: false,
        flag: false,
        error: false,
      }
    }
    default:
      return state
  }
}
